import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { LogOut, Mail } from 'lucide-react';
import SEO from '../components/SEO';
import AppShell from '../components/AppShell';
import { clearAuthToken } from '../lib/auth';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Profile = () => {
  const [user, setUser] = useState(null);
  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/auth/me`)
      .then((r) => { if (!cancelled) setUser(r.data); })
      .catch(() => { /* handled */ });
    return () => { cancelled = true; };
  }, []);

  const handleSignOut = async () => {
    try { await axios.post(`${API}/auth/logout`, {}); } catch { /* ignore */ }
    clearAuthToken();
    window.location.href = '/';
  };

  return (
    <AppShell>
      <SEO title="Profile" description="Your Summaros account." path="/profile" noindex />
      <section className="max-w-2xl mx-auto px-6 sm:px-8 py-16 sm:py-20 animate-fade-up" data-testid="profile-page">
        <p className="eyebrow mb-5">Profile</p>
        <h1
          className="display-serif text-4xl sm:text-5xl text-forest mb-10"
          style={{ fontVariationSettings: "'opsz' 96, 'SOFT' 50, 'wght' 360" }}
        >
          You.
        </h1>

        <div className="card bg-cream-soft space-y-5">
          <div className="flex items-center gap-4">
            {user?.picture ? (
              <img
                src={user.picture}
                alt=""
                className="w-14 h-14 rounded-full border border-line object-cover"
                referrerPolicy="no-referrer"
              />
            ) : (
              <div className="w-14 h-14 rounded-full bg-forest text-cream flex items-center justify-center font-display text-xl">
                {(user?.name || '?').slice(0, 1)}
              </div>
            )}
            <div>
              <p className="font-medium text-forest text-[17px]" data-testid="profile-name">
                {user?.name || '—'}
              </p>
              <p className="text-sm text-ink-muted inline-flex items-center gap-1.5" data-testid="profile-email">
                <Mail className="w-3.5 h-3.5" strokeWidth={1.5} />
                {user?.email || '—'}
              </p>
            </div>
          </div>

          <div className="pt-5 border-t border-line flex flex-wrap gap-3">
            <Link to="/my-life" className="btn-secondary">Back to My Life</Link>
            <button onClick={handleSignOut} className="btn-secondary" data-testid="profile-signout">
              <LogOut className="w-4 h-4" strokeWidth={1.5} />
              Sign out
            </button>
          </div>
        </div>

      <p className="mt-6 text-xs text-ink-faint">
        Your assessment, profile and timeline are private and stay with you.
      </p>
      </section>
    </AppShell>
  );
};

export default Profile;
